/* eslint-disable */
import React, { useState, useEffect } from "react";
import "./promotionBanner.scss";
// localizations
import { withTranslation, useTranslation } from "react-i18next";
// import Redux
import { useDispatch, useSelector } from "react-redux";
import CloseIcon from "../../layout-one/js/assets/images/closeBtn.svg";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";

function PromotionBannerPopup(props) {
  const { t } = useTranslation();
  const appState = useSelector((state) => state);
  const appDispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);
  
  const handleClose = () => {
    appDispatch({ type: "setPromotionBanner", promotionBanner: false });
    sessionStorage.setItem(`adPopupClosed${appState.storeInfo.slug}`, "true");
  };

  const onLoad = (i) => {
    if (i === appState.storeInfo.banners.length - 1) {
      setOpen(true);
    }
  };

  const handleRedirect = (banner) => {
    if (banner?.link) {
      window.location.replace(banner?.link);
    }
  };

  // Navigate to next slide
  const handleNext = () => {
    if (appState.storeInfo.banners && appState.storeInfo.banners.length > 0) {
      setCurrentIndex((prevIndex) => 
        prevIndex === appState.storeInfo.banners.length - 1 ? 0 : prevIndex + 1
      );
    }
  };

  // Navigate to previous slide
  const handlePrev = () => {
    if (appState.storeInfo.banners && appState.storeInfo.banners.length > 0) {
      setCurrentIndex((prevIndex) => 
        prevIndex === 0 ? appState.storeInfo.banners.length - 1 : prevIndex - 1
      );
    }
  };

  // Touch/Swipe handlers
  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;

    if (isLeftSwipe) {
      handleNext();
    }
    if (isRightSwipe) {
      handlePrev();
    }

    // Reset
    setTouchStart(0);
    setTouchEnd(0);
  };

  // Auto-play functionality
  useEffect(() => {
    if (appState.storeInfo.banners && appState.storeInfo.banners.length > 1) {
      const interval = setInterval(() => {
        handleNext();
      }, 3000); // Change slide every 3 seconds

      return () => clearInterval(interval);
    }
  }, [currentIndex, appState.storeInfo.banners]);

  return (
    appState.storeInfo.banners.length > 0 && (
      <>
        <div
          id="mySidenav"
          className={`promotionBannerPopup col-xl-5 py-3   ${
            appState.langValue == "ar" ? "promotionBannerPopupArabic" : " "
          }`} 
        >    
          {
            <Dialog
              style={open ? {} : { display: "none" }}
              className="classToTargetPBModal"
              open={appState.promotionBanner}
              // onClose={handleClose}
            >
              <DialogContent className="p-0">
                <button
                  type="button"
                  onClick={handleClose}
                  className="close pb-1"
                >
                  <span aria-hidden="true">
                    <img src={CloseIcon} alt="CloseIcon" />
                  </span>
                </button>
                
                {/* Custom Image Gallery with Touch/Swipe Support */}
                <div 
                  className="custom-gallery-container"
                  onTouchStart={handleTouchStart}
                  onTouchMove={handleTouchMove}
                  onTouchEnd={handleTouchEnd}
                >
                  <div className="gallery-slider">
                    {appState.storeInfo.banners != [] &&
                      appState.storeInfo.banners.map((banner, i) => {
                        return (
                          <div
                            className={`gallery-slide ${i === currentIndex ? 'active' : ''} ${
                              appState.langValue === "ar" ? "directionRtl" : ""
                            }`}
                            key={i}
                            onClick={() => handleRedirect(banner)}
                            style={{
                              display: i === currentIndex ? 'block' : 'none'
                            }}
                          >
                            <img
                              className="gallery-image"
                              src={banner.image}
                              alt={`Banner ${i + 1}`}
                              onLoad={() => onLoad(i)}
                            />
                          </div>
                        );
                      })}
                  </div>
                </div>
              </DialogContent>
            </Dialog>
          }
        </div>
      </>
    )
  );
}

export default withTranslation()(PromotionBannerPopup);
